<template>
  <div>
    <Table :columns="columns" :data="resources" size="small" stripe>
      <template slot-scope="{ row }" slot="permission_data">
        <ul class="ts-list-disc">
          <li>Trial Balance</li>
          <li>Balance Sheet</li>
          <li>Profit and Loss</li>
        </ul>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  name: 'tableExpand',
  props: {
    permission_reports: Array
  },
  data() {
    return {
      width: 'width: 300px'
    }
  },
  computed: {
    resources() {
      let resources = []
      this.permission_reports.forEach(resource => {
        resources.push(Object.assign(resource, { _deleting: false }))
      })
      return resources
    },
    columns() {
      return [
        {
          title: this.$t('user.companyName'),
          key: 'company_name_en'
        },
        {
          title: this.$t('user.permissionReport'),
          slot: 'permission_data'
        }
      ]
    }
  }
}
</script>
